import { render, staticRenderFns } from "./EstruturaForm.vue?vue&type=template&id=56462f63&lang=html&"
import script from "./EstruturaForm.vue?vue&type=script&lang=js&"
export * from "./EstruturaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/estrutura-usuario/EstruturaForm.vue
// module id = 1389
// module chunks = 28